export default {
  title: "Overview",
  provider: "Provider",
  services_types: "Services Types",
  unspecified: "--",
  edit_contact: "Edit Contact",
};
